import { computed } from 'vue'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { loadAutoLogin } from '@/constants/autoLogin'

export const SELLER_CENTER_PATH = '/seller'
export const SELLER_LOGIN_PATH = '/login?tab=seller'

/** 이미 띄운 창을 기억해 두고, 다시 누르면 새로 열지 않고 그 창을 앞으로 가져온다. */
let sellerWindow: Window | null = null

export function useSellerCenter() {
  const { seller, isSellerLoggedIn, initSellerAuth } = useSellerAuth()

  const canOpen = computed(() => isSellerLoggedIn.value)

  /**
   * 헤더를 보는 사람 대부분은 판매업체가 아니다.
   * 이 브라우저에서 판매업체로 로그인한 흔적이 있을 때만 서버에 세션을 확인한다.
   * 자동 로그인을 골랐다면 브라우저를 껐다 켜서 캐시가 비어 있어도 확인해야 한다.
   */
  const refreshSellerAuth = () => {
    if (seller.value || loadAutoLogin('seller')) {
      initSellerAuth()
    }
  }

  const openSellerCenter = () => {
    const target = isSellerLoggedIn.value ? SELLER_CENTER_PATH : SELLER_LOGIN_PATH

    if (sellerWindow && !sellerWindow.closed) {
      sellerWindow.focus()
      return
    }

    const width = Math.min(1480, window.screen.availWidth)
    const height = Math.min(960, window.screen.availHeight)
    const left = Math.max(0, Math.round((window.screen.availWidth - width) / 2))
    const top = Math.max(0, Math.round((window.screen.availHeight - height) / 2))

    sellerWindow = window.open(
      target,
      'hamwoori-seller-center',
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    )

    /* 팝업이 차단되면 같은 탭에서라도 열어 준다 */
    if (!sellerWindow) {
      window.location.href = target
      return
    }
    sellerWindow.focus()
  }

  return { seller, canOpen, openSellerCenter, refreshSellerAuth }
}
